export default __webpack_public_path__ + "static/media/NIAS0006.34I-43085_-25762_0.efcfef9a.jpg";